import(/* webpackMode: "eager" */ "/vercel/path0/src/components/about-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/achievements-drawer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contact-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/hero-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/skills-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/timeline-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSections"] */ "/vercel/path0/src/contexts/sections-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/hooks/useOnScreen.ts");
